import { useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { X, RotateCcw, Check, PenTool } from 'lucide-react';

export default function SignatureModal({ onConfirm, onClose }) {
  const sigRef = useRef(null);
  const [hasDrawn, setHasDrawn] = useState(false);

  const handleClear = () => {
    sigRef.current?.clear();
    setHasDrawn(false);
  };

  const handleConfirm = () => {
    if (!sigRef.current || sigRef.current.isEmpty()) return;
    const dataUrl = sigRef.current.toDataURL('image/png');
    onConfirm(dataUrl);
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4" data-testid="signature-modal">
      <div className="bg-[#111827] border border-white/10 rounded-2xl w-full max-w-lg shadow-[0_16px_50px_rgba(0,0,0,0.55)]">
        {/* Header */}
        <div className="flex items-center justify-between p-5 border-b border-white/10">
          <div className="flex items-center gap-2">
            <PenTool size={20} className="text-[var(--rn-green)]" />
            <h3 className="font-display text-lg font-semibold">Assinar Termo</h3>
          </div>
          <button onClick={onClose} className="p-2 rounded-xl hover:bg-white/10 transition-colors">
            <X size={18} />
          </button>
        </div>

        {/* Canvas */}
        <div className="p-5">
          <p className="text-sm text-white/50 mb-3">Desenhe sua assinatura abaixo com o dedo ou mouse:</p>
          <div className="rounded-xl border-2 border-dashed border-[rgba(0,255,163,0.3)] bg-white overflow-hidden">
            <SignatureCanvas
              ref={sigRef}
              penColor="black"
              canvasProps={{
                width: 460,
                height: 180,
                className: 'w-full',
                style: { width: '100%', height: '180px', touchAction: 'none' }
              }}
              onBegin={() => setHasDrawn(true)}
              data-testid="signature-canvas"
            />
          </div>
          <p className="text-xs text-white/30 mt-2 text-center">
            {hasDrawn ? 'Assinatura registrada' : 'Toque ou clique para assinar'}
          </p>
        </div>

        {/* Actions */}
        <div className="flex items-center gap-3 p-5 border-t border-white/10">
          <button
            onClick={handleClear}
            className="btn-ghost flex items-center gap-2 text-sm"
            data-testid="signature-clear-button"
          >
            <RotateCcw size={16} /> Limpar
          </button>
          <div className="flex-1" />
          <button
            onClick={onClose}
            className="btn-ghost text-sm"
          >
            Cancelar
          </button>
          <button
            onClick={handleConfirm}
            disabled={!hasDrawn}
            className={`flex items-center gap-2 text-sm py-2.5 px-5 rounded-xl font-semibold transition-all ${
              hasDrawn ? 'btn-primary' : 'bg-white/[0.06] text-white/30 cursor-not-allowed'
            }`}
            data-testid="signature-confirm-button"
          >
            <Check size={16} /> Confirmar Assinatura
          </button>
        </div>
      </div>
    </div>
  );
}
